import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Message, NotificationHelper } from './notification-helper';
import { NotificationService } from './notification.service';
import { PushNotify } from './push-notify/push-notify.component';
import { IdexService } from '../../idex.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
   selector: 'app-notification',
   templateUrl: './notification.component.html',
   styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, OnDestroy {
   @ViewChild('menuNoti') menuNoti: { closeMenu: () => void; };
   loading = true;
   newCount = 0;
   messages: Message[] = [];
   error = '';
   uploadNewVersion = '';
   noNotify = '';
   failTLoad = '';
   private subscription?: Subscription;
   private page = 0;
   private maxItem = 20;
   private totalElements = 0;

   constructor(public service: NotificationService, private notify: PushNotify, public helper: NotificationHelper,
               private titleService: Title, private iDexService: IdexService, private translate: TranslateService,
               private router: Router) { }

   ngOnInit(): void {
      this.subscription = this.service.messageArrived.subscribe((msg: Message) => this.messageArrived(msg));
      if (this.iDexService.user) {
         this.service.connect().subscribe(n => this.updateNewCount(n));
      }
   }

   ngOnDestroy(): void {
      this.service.disconnect();
      this.subscription?.unsubscribe();
   }

   open(): void {
      this.messages = [];
      this.loadData();
      this.markAsSeen();
   }

   readAll(): void {
      this.service.read().subscribe(() => this.messages.forEach((message) => message.readDate = new Date()));
   }

   onScroll(event: any): void {
      const tracker = event.target;
      const reachBottom = tracker.scrollHeight - tracker.clientHeight === Math.floor(tracker.scrollTop);
      if (reachBottom && this.messages.length < this.totalElements && !this.loading) {
         event.stopPropagation();
         this.page++;
         this.loadData();
      }
   }

   updateNewCount(newCount: number): void {
      this.newCount = newCount < 0 ? 0 : newCount;
      if (this.newCount) {
         this.titleService.setTitle(`(${this.newCount}) zDOX`);
      } else {
         this.titleService.setTitle(`zDOX`);
      }
   }

   private loadData(): void {
      this.loading = true;
      this.service.list(this.page, this.maxItem).subscribe({
         next: data => {
            this.totalElements = data.totalElements;
            data.content.forEach((msg: Message) => msg.payload = JSON.parse(msg.payload));
            this.messages.push(...data.content);
            this.error = '';
         },
         error: e => {
            this.error = e.message
            if (e.status === 403 || e.status === 200) {
               this.menuNoti.closeMenu();
            }
         }
      }).add(() => this.loading = false);
   }

   private markAsSeen(): void {
      if (this.newCount > 0) {
         this.service.seen().subscribe(() => this.updateNewCount(0));
      }
   }

   private messageArrived(msg: Message): void {
      this.updateNewCount(this.newCount + 1);
      msg.payload = JSON.parse(msg.payload);
      this.notify.show(msg).subscribe(() => this.updateNewCount(this.newCount - 1));
      if (this.messages.length) {
         this.messages.unshift(msg);
      }
   }

   openTaskNoti(msg: Message): void {
      if (msg.payload.type === 'task') {
         if (msg.payload.action !== 'deleted') {
            this.router.navigateByUrl('/signdoc/' + msg.payload.id);
         }
      } else if (msg.payload.type === 'dms') {
         if (msg.payload.action !== 'deleted' && msg.payload.action !== 'rename' && msg.payload.action !== 'move') {
            if (!msg.payload.isFolder) {
               this.router.navigateByUrl('/file/' + msg.payload.id);
            } else {
               this.router.navigateByUrl(msg.payload.folderPath);
            }
         }
      }
   }

   getCursor(msg: Message): string {
      return this.helper.getCursor(msg.payload);
   }
}
